import { anyOf, arrayOf, objectOf, recordOf } from "@altostra/type-validations";
import { nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import type {
  DecisioningCreativeComponentVariant,
  GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult,
} from "./types";

const isDecisioningCreativeComponentVariant = objectOf<DecisioningCreativeComponentVariant>({
  actionId: anyOf(number, nullValidation),
  creative: string,
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsResult>({
    results: recordOf(arrayOf(isDecisioningCreativeComponentVariant)),
  });
